// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofFadeFooter-cls1_43C","cls2":"SocialProofFadeFooter-cls2_-lH SocialProofFadeFooter-cls1_43C"};